<template>
    <div class="ui error message" ref="message">
        <i class="close icon" v-on:click="close"></i>
        <div v-if="error.header" class="header">
            {{error.header}}
        </div>
        <p v-if="!Array.isArray(error.message)">{{error.message}}</p>
        <ul v-if="Array.isArray(error.message)">
            <li v-for="msg in error.message">{{msg}}</li>
        </ul>
    </div>
</template>
<script>
    export default {
        props: ['error'],
        watch: {
            error(oldError, newError){
                $(this.$refs.message).transition('show');
            }
        },
        methods: {
            close(){
                $(this.$refs.message).transition('fade');
            }
        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/admin/errorDisplay.vue